import styled from 'styled-components/macro';
import Input from 'styled/Input';

export const InputStyled = styled(Input)`
  height: 35px;
  padding-left: 45px;
  padding-right: 30px;
  border: none;
`;

export default InputStyled;
